import React from "react";
import PropTypes from "prop-types";
import utils from "@utils";

const DatetimeInput = props => {
	const { name, id, minStartDate, startDate, onJobDateChange } = props;

	const convertToDashFormat = date => {
		const dateDestruct = date.split("/");
		if (dateDestruct.length === 3) {
			const newDate = `${dateDestruct[2]}-${dateDestruct[0]}-${dateDestruct[1]}`;
			return newDate;
		}
		return date;
	};

	return (
		<Choose>
			<When condition={utils.isDesktopSafari || utils.isIE}>
				<input
					name={name}
					id={id}
					className="form-control"
					type="date"
					min={convertToDashFormat(minStartDate)}
					value={convertToDashFormat(startDate)}
					onKeyDown={e => e.preventDefault()}
					onChange={onJobDateChange}
				/>
			</When>
			<Otherwise>
				<input
					name={name}
					id={id}
					className="form-control"
					type="date"
					min={minStartDate}
					value={startDate}
					onChange={onJobDateChange}
				/>
			</Otherwise>
		</Choose>
	);
};

DatetimeInput.propTypes = {
	name: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	minStartDate: PropTypes.bool,
	onJobDateChange: PropTypes.func.isRequired,
	startDate: PropTypes.string.isRequired,
};

DatetimeInput.defaultProps = {
	minStartDate: utils.formatDate(undefined, undefined, undefined, "noslash"),
};

export default DatetimeInput;
